import { Component, TemplateRef, ViewChild, ChangeDetectorRef, AfterViewInit, ElementRef } from '@angular/core';
import { PerfilComponent } from '../perfil/perfil.component';
import { PropiedadService } from 'src/app/services/propiedad.service';
import { Observable, BehaviorSubject } from 'rxjs';
import { UserService } from 'src/app/services/user.service';
import { MatDialog, MatPaginator, MatTableDataSource } from '@angular/material';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { NgxSpinnerService } from 'ngx-spinner';
import { map, startWith } from 'rxjs/operators';
import { Propiedades } from 'src/app/models/propiedades.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GLOBAL } from 'src/app/services/global';
import { Http } from '@angular/http';
import { Store } from '@ngrx/store';
import { Form, FormControl, Validators } from '@angular/forms';
import * as FormActions from '../../reducers/actions/forms.actions';
import { Router } from '@angular/router';
import { ClaveUnicaService } from 'src/app/services/clave_unica.service';
import { RegistroComponent } from '../home/registro/registro.component';
import { rutClean } from 'rut-helpers';

declare const swal: any;
declare const google: any;

interface AppState {
    form: Form;
}


@Component({
    selector: "page-totem-busqueda-direccion",
    templateUrl: "totem-busqueda-direccion.component.html",
    styleUrls: ["./totem-busqueda-direccion.component.css"],
    providers: [UserService, PropiedadService, ClaveUnicaService],

})

export class TotemBusquedaDireccionComponent {
    @ViewChild('direccionesDialog') direccionesDialog: TemplateRef<any>;
    public errorMessage = ''
    displayedColumns: string[] = ['PDI_Direc_Completa']
    public certificado_info
    public arreglo
    buscando = false
    public rol = new FormControl('', [Validators.required]);
    public calle = new FormControl('', [Validators.required]);
    public nroCalle = new FormControl('', [Validators.required]);
    public rol_busqueda
    public inforol
    public address
    public geolocationRes
    public comunaMapa = GLOBAL.nombreMuni;
    public ubicacion = ''
    public sitio = ''
    public manzana = ''
    public zonaprc = ''
    public conjHabit = ''
    public aup = ''

    locaciones = []

    markers = []

    marcadores: Marcador[] = [];

    public Propiedades: Propiedades;
    public direcciones: MatTableDataSource<Propiedades>;
    documentos: MatTableDataSource<any>;
    dataCips: MatTableDataSource<any>;

    identity
    token

    @ViewChild('mapContainer') gmap: ElementRef;

    map: any;
    mapOptions
    coordinates
    marker
    calles
    bandera = false

    filteredOptions
    calleform = new FormControl("")
    dires = []
    dirSeleccionada

    //asdasd  //para en guardar el nombre de la primera direccion

    //coordenadas del centro de peñaflor //la florida
    public lat: number = -33.60627    //-33.53071445
    public lng: number = -70.87649   //-70.54402715
    public nombreMarker: string = ''


    constructor(private _snackBar: MatSnackBar, private dialog: MatDialog, private store: Store<AppState>, private _user: UserService, private spinner: NgxSpinnerService, private _cd: ChangeDetectorRef,
        public http: Http, private elementRef: ElementRef, private _prop: PropiedadService, private _router: Router, private claveUnicaService: ClaveUnicaService) {
        //console.log(this.rol)
        this.spinner.show()
        this.map = google.maps.Map;
        this._prop.getCalles().subscribe(response => {
            this.calles = response.calles
            this.bandera = true
            this.spinner.hide()
        }, error => {
            console.log(error)
            // this.spinner.hide()
        })

        this.identity = this._user.getIdentity();
        this.token = this._user.getToken();

      /*   if (sessionStorage.getItem('identity-domCloud')) {
            this.searchUser()
          }else {
            this._router.navigate(['/inicio'])
            swal({
              type: 'warning',
              title: "Para acceder a estos servicios, deberá iniciar sesión con su clave de sistema o su clave única.",
              showConfirmButton: true,
              confirmButtonText: 'Aceptar',
              allowOutsideClick: false
            })
          } */
    }

    ngOnInit() {

        this.filteredOptions = this.calle.valueChanges.pipe(
            startWith(''),
            map(value => this._filter(value))
        );

    }

    private _filter(value: string): string[] {
        const filterValue = value.toLowerCase();
        return this.calles.filter(option => option.toLowerCase().indexOf(filterValue) === 0);
    }

    buscar(rol?, calle?, num?) {

        var dirs = []

        this.spinner.show()
        if (this.rol.valid) {
            this._user.get_direccion_rol(this.rol.value).subscribe(response => {
                if (response.status == "error") {
                    this.spinner.hide()
                    console.log(response.message)
                    swal({
                        type: 'warning',
                        title: 'Atención!',
                        text: response.message,
                        confirmButtonColor: '#3F51B5',
                        confirmButtonText: 'Aceptar',
                        timer: 3500
                    }).then(() => {
                    }, (dismiss) => {
                        if (dismiss === 'timer') {
                        }
                    });
                } else {

                    if (response.rescompleta.response.data.length > 1) {

                        for (let i = 0; i < response.rescompleta.response.data.length; i++) {
                            const element = response.rescompleta.response.data[i].fieldData;
                            this.dires.push(element)
                        }
                        this.dialog.open(this.direccionesDialog, { disableClose: true })
                        this.spinner.hide()

                    } else {
                        this.rol_busqueda = this.rol.value

                        this._cd.detectChanges();

                        if (response.rescompleta.response.data.length > 0) {


                            for (let x = 0; x < response.rescompleta.response.data.length; x++) {
                                const element = response.rescompleta.response.data[x].fieldData;
                                var defaultObj = {
                                    'PDI_Direc_Completa': response.rescompleta.response.data[x].fieldData['PDI_Direc_Completa']
                                }
                                dirs.push(defaultObj)
                                var defaultObj2 = {
                                    'PDI_Calle_Nombre': response.rescompleta.response.data[x].fieldData['PDI_Calle_Nombre'],
                                    'PDI_Num_Calle': response.rescompleta.response.data[x].fieldData['PDI_Num_Calle']
                                }
                                this.markers.push(defaultObj2)
                            }

                            this.direcciones = new MatTableDataSource(dirs)
                        } else {
                            var defaultObjX = {
                                'PDI_Direc_Completa': ""
                            }
                            dirs.push(defaultObjX)
                            this.markers.push(defaultObjX)
                            this.direcciones = new MatTableDataSource(dirs)
                        }

                        //console.log("va bien: ",response.rescompleta,  dirs)
                        this.inforol = response
                        this.ubicacion = response.res.fieldData['Propiedad::Pro_Propie_Ubicacion']
                        this.manzana = response.res.fieldData['Propiedad::Pro_Propie_Manzana']
                        this.sitio = response.res.fieldData['Propiedad::Pro_Propie_Sitio']

                        if (this.marcadores.length > 0) {
                            this.marcadores = [];
                        }


                        this._user.get_predio(this.rol_busqueda).subscribe(resultado => {

                            this.zonaprc = resultado.res.response.data[0].fieldData['Pro_Propie_Zona_Edif']
                            this.conjHabit = resultado.res.response.data[0].fieldData['Conj_Habit::CONJ_Nombre_Completo']
                            this.aup = resultado.res.response.data[0].fieldData['Pro_Propie_Afecta']
                            if (this.manzana == "" && resultado.res.response.data[0].fieldData['Pro_Propie_Manzana'] != "") {
                                this.manzana = resultado.res.response.data[0].fieldData['Pro_Propie_Manzana']
                            }
                            if (this.sitio == "" && resultado.res.response.data[0].fieldData['Pro_Propie_Sitio'] != "") {
                                this.sitio = resultado.res.response.data[0].fieldData['Pro_Propie_Sitio']
                            }
                            //console.log('get_predio',resultado)
                        })


                        //this.markers = dirs
                        this.createMap()

                        this.buscando = true
                        this.spinner.hide()
                    }

                }

            }, error => {
                console.log(error)
                this.spinner.hide()
                swal({
                    type: 'warning',
                    title: 'Atención!',
                    text: 'Error Inesperado, Intente más tarde',
                    confirmButtonColor: '#3F51B5',
                    confirmButtonText: 'Aceptar',
                    timer: 3500
                }).then(() => {
                }, (dismiss) => {
                    if (dismiss === 'timer') {
                    }
                })
                this.spinner.hide()
            })
        } else if (this.calle.valid && this.nroCalle.valid) {
            this._user.get_direccion_callenum(this.calle.value, this.nroCalle.value).subscribe(response => {
                if (response.status == "error") {
                    this.spinner.hide()
                    swal({
                        type: 'warning',
                        title: 'Atención!',
                        text: response.message,
                        confirmButtonColor: '#3F51B5',
                        confirmButtonText: 'Aceptar',
                        timer: 3500
                    }).then(() => {
                    }, (dismiss) => {
                        if (dismiss === 'timer') {
                        }
                    });
                    this.calle.setValue("")
                    this.nroCalle.setValue("")
                } else {

                    if (response.res.response.data.length > 1) {
                        for (let i = 0; i < response.res.response.data.length; i++) {
                            const element = response.res.response.data[i].fieldData;
                            this.dires.push(element)
                        }
                        this.dialog.open(this.direccionesDialog, { disableClose: true })
                        this.spinner.hide()
                    } else {
                        //console.log("busqueda por calle y nro: ", response.rol)
                        this.rol_busqueda = response.rol
                        this._user.get_direccion_rol(this.rol_busqueda).subscribe(response => {

                            //this.rol_busqueda = this.rol.value                    
                            this._cd.detectChanges();

                            if (response.rescompleta.response.data.length > 0) {
                                for (let x = 0; x < response.rescompleta.response.data.length; x++) {
                                    const element = response.rescompleta.response.data[x].fieldData;
                                    var defaultObj = {
                                        'PDI_Direc_Completa': response.rescompleta.response.data[x].fieldData['PDI_Direc_Completa']
                                    }
                                    dirs.push(defaultObj)

                                    var defaultObj2 = {
                                        'PDI_Calle_Nombre': response.rescompleta.response.data[x].fieldData['PDI_Calle_Nombre'],
                                        'PDI_Num_Calle': response.rescompleta.response.data[x].fieldData['PDI_Num_Calle']
                                    }
                                    this.markers.push(defaultObj2)
                                }

                                this.direcciones = new MatTableDataSource(dirs)
                            } else {
                                var defaultObjX = {
                                    'PDI_Direc_Completa': ""
                                }
                                dirs.push(defaultObjX)
                                this.markers.push(defaultObjX)
                                this.direcciones = new MatTableDataSource(dirs)
                            }

                            this.inforol = response

                            this.ubicacion = response.res.fieldData['Propiedad::Pro_Propie_Ubicacion']
                            this.manzana = response.res.fieldData['Propiedad::Pro_Propie_Manzana']
                            this.sitio = response.res.fieldData['Propiedad::Pro_Propie_Sitio']

                            if (this.marcadores.length > 0) {
                                this.marcadores = [];
                            }


                            this._user.get_predio(this.rol_busqueda).subscribe(resultado => {
                                this.zonaprc = resultado.res.response.data[0].fieldData['Pro_Propie_Zona_Edif']
                                this.conjHabit = resultado.res.response.data[0].fieldData['Conj_Habit::CONJ_Nombre_Completo']
                                this.aup = resultado.res.response.data[0].fieldData['Pro_Propie_Afecta']
                                if (this.manzana == "" && resultado.res.response.data[0].fieldData['Pro_Propie_Manzana'] != "") {
                                    this.manzana = resultado.res.response.data[0].fieldData['Pro_Propie_Manzana']
                                }
                                if (this.sitio == "" && resultado.res.response.data[0].fieldData['Pro_Propie_Sitio'] != "") {
                                    this.sitio = resultado.res.response.data[0].fieldData['Pro_Propie_Sitio']
                                }
                                //console.log('get_predio',resultado)
                            })


                            //this.markers = dirs
                            this.createMap()

                            this.buscando = true
                            this.spinner.hide()

                        }, error => {

                            this.spinner.hide()
                            console.log(error)
                        })
                    }

                }


            }, error => {
                this.spinner.hide()
                console.log(error)
                this.errorMessage = JSON.parse(error._body)
                swal({
                    type: 'warning',
                    title: 'Atención!',
                    text: 'Error Inesperado, Intente más tarde',
                    confirmButtonColor: '#3F51B5',
                    confirmButtonText: 'Aceptar',
                    timer: 3500
                }).then(() => {
                }, (dismiss) => {
                    if (dismiss === 'timer') {
                    }
                })
            })
        }

    }

    insertarDir() {
        this.spinner.show()
        this._cd.detectChanges();
        let dirs = []
        this.rol_busqueda = this.dirSeleccionada['Propiedad::Pro_Propie_ROL']
        // if (this.dirSeleccionada.length > 0) {
        // for (let x = 0; x < this.dirSeleccionada.length; x++) {
        //     const element = this.dirSeleccionada;
        var defaultObj = {
            'PDI_Direc_Completa': this.dirSeleccionada['PDI_Direc_Completa']
        }
        dirs.push(defaultObj)

        var defaultObj2 = {
            'PDI_Calle_Nombre': this.dirSeleccionada['PDI_Calle_Nombre'],
            'PDI_Num_Calle': this.dirSeleccionada['PDI_Num_Calle']
        }
        this.markers.push(defaultObj2)
        // }

        this.direcciones = new MatTableDataSource(dirs)
        // } else {
        //     var defaultObjX = {
        //         'PDI_Direc_Completa': ""
        //     }
        //     dirs.push(defaultObjX)
        //     this.markers.push(defaultObjX)
        //     this.direcciones = new MatTableDataSource(dirs)
        // }
        this.inforol = this.dirSeleccionada

        this.ubicacion = this.dirSeleccionada['Propiedad::Pro_Propie_Ubicacion']
        this.manzana = this.dirSeleccionada['Propiedad::Pro_Propie_Manzana']
        this.sitio = this.dirSeleccionada['Propiedad::Pro_Propie_Sitio']

        if (this.marcadores.length > 0) {
            this.marcadores = [];
        }


        this._user.get_predio(this.dirSeleccionada['Propiedad::Pro_Propie_ROL']).subscribe(resultado => {
            this.zonaprc = resultado.res.response.data[0].fieldData['Pro_Propie_Zona_Edif']
            this.conjHabit = resultado.res.response.data[0].fieldData['Conj_Habit::CONJ_Nombre_Completo']
            this.aup = resultado.res.response.data[0].fieldData['Pro_Propie_Afecta']
            if (this.manzana == "" && resultado.res.response.data[0].fieldData['Pro_Propie_Manzana'] != "") {
                this.manzana = resultado.res.response.data[0].fieldData['Pro_Propie_Manzana']
            }
            if (this.sitio == "" && resultado.res.response.data[0].fieldData['Pro_Propie_Sitio'] != "") {
                this.sitio = resultado.res.response.data[0].fieldData['Pro_Propie_Sitio']
            }
            //console.log('get_predio',resultado)
        })


        //this.markers = dirs
        this.dialog.closeAll()
        this.createMap()

        this.buscando = true
        this.spinner.hide()
    }

    mapInitializer() {
        this.map = new google.maps.Map(this.gmap.nativeElement, this.mapOptions);
    }

    centerChange(event) {
        //console.log(event);
    }
    ChangeMap(event) {
        //console.log(event);
    }


    getGeolocation(dirSimb, dirReal) {

        let dataLatLng

        //crear servicio nomatim 

        //console.log("https://nominatim.openstreetmap.org/search.php?q="+address+"%20la%20florida%20santiago&polygon_geojson=1&format=jsonv2")
        //let geocoder = "https://nominatim.openstreetmap.org/search.php?q="+address+"%20la%20florida%20santiago&polygon_geojson=1&format=jsonv2"
        dataLatLng = this.http.get("https://nominatim.openstreetmap.org/search.php?q=" + dirSimb + "%20" + this.comunaMapa + "&polygon_geojson=1&format=jsonv2").subscribe(
            (datos: any) => {
                //asdasd=JSON.stringify(datos);
                //dataLatLng=eval(datos);//JSON.stringify(datos);

                try {
                    console.log("datos de nomatim : ", datos)

                    //console.log("datos de respuestas desde nominatim: ",JSON.parse(datos['_body']))
                    dataLatLng = JSON.parse(datos['_body'])

                    if (dataLatLng == '[]') {
                        console.log("objeto vacio")
                    } else {

                        this.lat = parseFloat(dataLatLng[0]['lat'])
                        this.lng = parseFloat(dataLatLng[0]['lon'])

                        console.log(dirSimb, this.lat + " " + this.lng)
                        //this.nombreMarker = dirSimb.replace("%20", " ")

                        var nuevoMarcador = new Marcador(this.lat, this.lng, dirReal)
                        //guarda latitud, longitud y nombre para los marker del mapa
                        this.marcadores.push(nuevoMarcador);
                    }


                    /***********************/



                } catch (error) {
                    console.log(error, datos)
                }

            }
        )
    }

    async createMap() {
        //location

        this.markers.forEach(element => {
            //cambiar 
            var nomCalle = element['PDI_Calle_Nombre'] + ' ' + element['PDI_Num_Calle'] + ' ' + GLOBAL.nombreMuni
            let geocoder = new google.maps.Geocoder
            geocoder.geocode({ address: nomCalle, }, (resy, status) => {

                if (status === 'OK') {
                    this.locaciones.push(resy[0].geometry.location)
                } else {
                    console.log('GeocoderMarker failed due to: ' + status, nomCalle);
                }

            }, error => {
                console.log(error)
            })

            /* let dataCalle = element['PDI_Calle_Nombre'].replace(" ", "%20")
            dataCalle = dataCalle.replace(/\n|\r|\r\n/g, "%20")

            this.getGeolocation(dataCalle+'%20'+element['PDI_Num_Calle']+ '%20Rancagua', element['PDI_Calle_Nombre']+' '+element['PDI_Num_Calle']) */


        })

        setTimeout(() => {

            //las coordenadas iniciales son del centro de peñaflor
            this.mapOptions = google.maps.MapOptions = {
                center: { lat: -33.60627, lng: -70.87649 },
                zoom: 14,
                scaleControl: true
            };
            this.mapInitializer();
            var bounds = new google.maps.LatLngBounds();
            this.markers.forEach((element, ind) => {

                var nomCalle = element['PDI_Calle_Nombre'] + ' ' + element['PDI_Num_Calle']

                //new google.maps.LatLng(locations[i][1], locations[i][2]),
                var markerx = new google.maps.Marker({
                    position: this.locaciones[ind],
                    map: this.map,
                    title: nomCalle,
                });

                bounds.extend(markerx.position);
                this.attachSecretMessage(markerx, nomCalle);

            })

            this.map.fitBounds(bounds);
            //console.log("marcadores: ",this.marcadores[0].lat, this.marcadores[0].lng, this.marcadores[0].titulo)


        }, 4000);
    }

    attachSecretMessage(marker, secretMessage: string) {

        const infowindow = new google.maps.InfoWindow({
            content: secretMessage,
        });

        marker.addListener("click", () => {
            infowindow.open(marker.get("map"), marker);
        });
    }
   

    volver() {
        this.buscando = false
        this.rol.setValue("")
        this.calle.setValue("")
        this.nroCalle.setValue("")
        this.deleteMarkers()
    }


    deleteMarkers() {
        //this.clearMarkers();
        this.markers = [];
    }

    async logout() {
        this.store.dispatch(new FormActions.FormUpdate('0', ''))
        sessionStorage.removeItem("identity-domCloud");
        sessionStorage.removeItem("token-domCloud");

        const response = await this.claveUnicaService.logoutClaveUnica()
        console.log('Deslogeo exitoso:', response);

        this._snackBar.open("Se ha cerrado sesión", "Cerrar", {
            duration: 3000,
        });
        this.back()
    }
    openPerfil() {
        this.dialog.open(PerfilComponent)
    }

    back() {
        this._router.navigate(['/inicio'])
    }

    
  searchUser() {
    /* Buscar si existe en fm */
    let identityData = this._user.getIdentity();
    let rut = identityData.rut + identityData.dv
    this._user.buscarUsuario(rutClean(rut)).subscribe(
      response => {
        if (response.message) {
            this.spinner.hide();
            console.log(response);
  
          }
          if (response.register) {
            this.spinner.hide();
            console.log(response);
  
            this.dialog.open(RegistroComponent, {
              id: "logindialog",
              width: '50vw', // Ajusta el ancho
              height: 'auto', // Ajusta la altura
              disableClose: true // Evita cerrar al hacer clic fuera (opcional)
            });
          }
  
          if (response.update) {
            this.spinner.hide();
            console.log(response);
  
            this.dialog.open(RegistroComponent, {
              id: "logindialog",
              width: '50vw', // Ajusta el ancho
              height: 'auto', // Ajusta la altura
              disableClose: true // Evita cerrar al hacer clic fuera (opcional)
            });
          }

      },
      error => {
        let e = JSON.parse(error._body);
        this.spinner.hide();
      }
    )
  }

}




export class Marcador {
    public lat: number;
    public lng: number;
    public titulo = 'Sin titulo';

    constructor(lat: number, lng: number, titulo: string) {
        this.lat = lat;
        this.lng = lng;
        this.titulo = titulo
    }
}